









import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import Calendar from './Calendar'

settings =
  name: 'MiniCalendar'

  vue:
    props: ['events', 'seasons', 'options', 'actions']

    components: { Calendar }

    computed:
      calendarEvents: ->
        events = @events || []
        events = events.map((e) => { date: e.date, display: 'background' })
        events

      calendarOptions: ->
        {
          ...@options,
          validRange: {},
          aspectRatio: @options?.aspectRatio || 1.22,
        }

export default VueOptions.vue settings
